import { useEffect, useRef, useState } from 'react';

import { useMytaverseEvent } from '@core/dashboard/providers';

import { IGamecastVideoStats } from '../../interfaces';

const useStats = () => {
  const { gamecastStats } = useMytaverseEvent();

  const intervalRef = useRef<NodeJS.Timeout>();
  const [stats, setStats] = useState<IGamecastVideoStats | null>(null);

  useEffect(() => {
    setStats(gamecastStats.current as IGamecastVideoStats);
    intervalRef.current = setInterval(() => {
      setStats(gamecastStats.current as IGamecastVideoStats);
    }, 2000);

    return () => {
      clearInterval(intervalRef.current);
    };
  }, []);

  return { stats };
};

export default useStats;
